import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams }from 'react-router-dom';
import { Form, Button} from 'react-bootstrap';
import FormContainer from '../../components/FormContainer';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import { useUpdateUserMutation, useGetUserDetailsQuery } from '../../slices/usersApiSlice';


const UserEditScreen = () => {
  const { id: userId } = useParams();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const { data: user, isLoading, refetch, error } = useGetUserDetailsQuery(userId);

  const [updateUser, { isLoading: loadingUpdate }] = useUpdateUserMutation();

  const navigate = useNavigate();

  useEffect(() => { 
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setIsAdmin(user.isAdmin);
    }
  }, [user]);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateUser({ userId, name, email, isAdmin });
      toast.success("會員資料已更新");
      refetch();
      navigate("/admin/userlist");
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
  <>
    <Link to="/admin/userlist" className="btn btn-light my-3">
    返回
    </Link>
    <FormContainer>
      <h1>編輯會員</h1>
      {loadingUpdate && <Loader />}

      {isLoading ? <Loader /> : error ? <Message variant="danger">{error}</Message> : (
        <Form onSubmit= { submitHandler }>
          <Form.Group controlId="name" className="my-2">
            <Form.Label>姓名</Form.Label>
            <Form.Control
              type="text"
              placeholder="請輸入姓名"
              value={name}
              onChange={(e) => setName(e.target.value)}
            >
            </Form.Control>
          </Form.Group>
      
          <Form.Group controlId="email" className="my-2">
            <Form.Label>電子郵件</Form.Label>
            <Form.Control
              type="email"
              placeholder="請輸入電子郵件"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            >
            </Form.Control>
          </Form.Group>
          
          <Form.Group conrolId="isAdmin" className="my-2">
            <Form.Check
              type="checkbox"
              label="管理員權限"
              checked={isAdmin}
              onChange={(e) => setIsAdmin(e.target.checked)}
            ></Form.Check>
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            className="my-2"
          >
            更新
          </Button>
        </Form>
      )}
    </FormContainer>
  </>
  )
};

export default UserEditScreen;